import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import Swal from 'sweetalert2'
import { AllowFloats, handlePaste } from '../../CommonUtils/CommonValidations'
import * as Yup from 'yup'
import { ERROR_MSG } from '../../CommonUtils/contextVariables'
import { CommonAxiosPost } from '../../CommonUtils/CommonAxios'
import { config } from '../../CommonUtils/CommonURLS'
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts'
import * as bie from "react-bootstrap";

export default function FFCADeficiencyRepot({ name, setIndex, x, onSuccessSubmit }) {
    let LandType = "SqFt/SqMtr";
    const ffacaFormik = useFormik({
        initialValues: {
            ownLeased: "",
            landNorms: "",
            landAvailable: "",
            landDeficiency: "",

            noOfVolumeNorms: "",
            noOfVolumeAvailable: "",
            noOfVolumeDeficiency: "",
            noOfTitlesDeficiency: "",
            noOfTitlesAvailable: "",
            noOfTitlesNorms: "",
            noOfLibraryDeficiency: "",
            noOfLibraryAvailable: "",
            noOfLibraryNorms: "",
            noOfLabsDeficiency: "",
            noOfLabsAvailable: "",
            noOfLabsNorms: "",
            noOfClassroomsDeficiency: "",
            noOfClassroomsAvailable: "",
            noOfClassroomsNorms: "",
            principalRoomNorms: "",
            principalRoomAvailable: "",
            principalRoomDeficiency: "",
            staffRoomNorms: "",
            staffRoomAvailable: "",
            staffRoomDeficiency: "",
            seminarHallNorms: "",
            seminarHallAvailable: "",
            seminarHallDeficiency: "",

            maleNorms: "",
            maleAvailable: "",
            maleDeficiency: "",
            femaleNorms: "",
            femaleAvailable: "",
            femaleDeficiency: "",
            parkingNorms: "",
            parkingAvailable: "",
            parkingDeficiency: "",
            playgroundNorms: "",
            playgroundAvailable: "",
            playgroundDeficiency: "",
        },
        validationSchema: Yup.object().shape({
            ownLeased: Yup.string().required(ERROR_MSG).nullable(),
            landNorms: Yup.string().required(ERROR_MSG).nullable(),
            landAvailable: Yup.string().required(ERROR_MSG).nullable(),


            noOfVolumeNorms: Yup.string().required(ERROR_MSG).nullable(),
            noOfVolumeAvailable: Yup.string().required(ERROR_MSG).nullable(),


            noOfTitlesAvailable: Yup.string().required(ERROR_MSG).nullable(),
            noOfTitlesNorms: Yup.string().required(ERROR_MSG).nullable(),

            noOfLibraryAvailable: Yup.string().required(ERROR_MSG).nullable(),
            noOfLibraryNorms: Yup.string().required(ERROR_MSG).nullable(),

            noOfLabsAvailable: Yup.string().required(ERROR_MSG).nullable(),
            noOfLabsNorms: Yup.string().required(ERROR_MSG).nullable(),

            noOfClassroomsAvailable: Yup.string().required(ERROR_MSG).nullable(),
            noOfClassroomsNorms: Yup.string().required(ERROR_MSG).nullable(),
            principalRoomNorms: Yup.string().required(ERROR_MSG).nullable(),
            principalRoomAvailable: Yup.string().required(ERROR_MSG).nullable(),

            staffRoomNorms: Yup.string().required(ERROR_MSG).nullable(),
            staffRoomAvailable: Yup.string().required(ERROR_MSG).nullable(),

            seminarHallNorms: Yup.string().required(ERROR_MSG).nullable(),
            seminarHallAvailable: Yup.string().required(ERROR_MSG).nullable(),

            maleNorms: Yup.string().required(ERROR_MSG).nullable(),
            maleAvailable: Yup.string().required(ERROR_MSG).nullable(),

            femaleNorms: Yup.string().required(ERROR_MSG).nullable(),
            femaleAvailable: Yup.string().required(ERROR_MSG).nullable(),

            parkingNorms: Yup.string().required(ERROR_MSG).nullable(),
            parkingAvailable: Yup.string().required(ERROR_MSG).nullable(),

            playgroundNorms: Yup.string().required(ERROR_MSG).nullable(),
            playgroundAvailable: Yup.string().required(ERROR_MSG).nullable(),

        }),
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveafflffcadefdtls`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            Swal.fire({
                                text: res?.data?.sdesc,
                                icon: "success",
                                backdrop: true
                            }).then(() => {
                                x()
                                GetFFCADetailsData();
                                if (onSuccessSubmit) {
                                    onSuccessSubmit();
                                }
                            });
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                }
            });
        }

    })

    const handleAvailableChange = (availableName, normsName, deficiencyName, label) => (e) => {

        const available = parseFloat(e.target.value || 0);
        const norms = parseFloat(ffacaFormik?.values?.[normsName] || 0);

        //   if (available > norms) {
        //     Swal.fire({
        //       icon: "warning",
        //       title: "Invalid Input",
        //       text: `Available ${label} cannot be greater than required as per norms.`,
        //     }).then(() => {
        //       ffacaFormik.setFieldValue(availableName, "");
        //       ffacaFormik.setFieldValue(deficiencyName, "");
        //     });
        //     return;
        //   }

        let deficiency = norms - available;
        // const deficiency = (norms - available).toFixed(4);
        deficiency = deficiency < 0 ? 0 : parseFloat(deficiency.toFixed(4));
        ffacaFormik.setFieldValue(availableName, e.target.value);

        ffacaFormik.setFieldValue(deficiencyName, deficiency);
    };

    function GetFFCADetailsData() {
        if (name?.length > 0) {

            ffacaFormik.setFieldValue("ownLeased", name[0].own_leased)
            ffacaFormik.setFieldValue("landNorms", name[0].land_norms)
            ffacaFormik.setFieldValue("landAvailable", name[0].land_available)
            ffacaFormik.setFieldValue("landDeficiency", name[0].land_deficiency)

            ffacaFormik.setFieldValue("noOfVolumeNorms", name[0].no_of_volume_norms)
            ffacaFormik.setFieldValue("noOfVolumeAvailable", name[0].no_of_volume_available)
            ffacaFormik.setFieldValue("noOfVolumeDeficiency", name[0].no_of_volume_deficiency)
            ffacaFormik.setFieldValue("noOfTitlesDeficiency", name[0].no_of_titles_deficiency)
            ffacaFormik.setFieldValue("noOfTitlesAvailable", name[0].no_of_titles_available)
            ffacaFormik.setFieldValue("noOfTitlesNorms", name[0].no_of_titles_norms)
            ffacaFormik.setFieldValue("noOfLibraryDeficiency", name[0].no_of_library_deficiency)
            ffacaFormik.setFieldValue("noOfLibraryAvailable", name[0].no_of_library_available)
            ffacaFormik.setFieldValue("noOfLibraryNorms", name[0].no_of_library_norms)
            ffacaFormik.setFieldValue("noOfLabsDeficiency", name[0].no_of_labs_deficiency)
            ffacaFormik.setFieldValue("noOfLabsAvailable", name[0].no_of_labs_available)
            ffacaFormik.setFieldValue("noOfLabsNorms", name[0].no_of_labs_norms)
            ffacaFormik.setFieldValue("noOfClassroomsDeficiency", name[0].no_of_classrooms_deficiency)
            ffacaFormik.setFieldValue("noOfClassroomsAvailable", name[0].no_of_classrooms_available)
            ffacaFormik.setFieldValue("noOfClassroomsNorms", name[0].no_of_classrooms_norms)
            ffacaFormik.setFieldValue("principalRoomNorms", name[0].principal_room_norms)
            ffacaFormik.setFieldValue("principalRoomAvailable", name[0].principal_room_available)
            ffacaFormik.setFieldValue("principalRoomDeficiency", name[0].principal_room_deficiency)
            ffacaFormik.setFieldValue("staffRoomNorms", name[0].staff_room_norms)
            ffacaFormik.setFieldValue("staffRoomAvailable", name[0].staff_room_available)
            ffacaFormik.setFieldValue("staffRoomDeficiency", name[0].staff_room_deficiency)
            ffacaFormik.setFieldValue("seminarHallNorms", name[0].seminar_hall_norms)
            ffacaFormik.setFieldValue("seminarHallAvailable", name[0].seminar_hall_available)
            ffacaFormik.setFieldValue("seminarHallDeficiency", name[0].seminar_hall_deficiency)

            ffacaFormik.setFieldValue("maleNorms", name[0].toilet_male_norms)
            ffacaFormik.setFieldValue("maleAvailable", name[0].toilet_male_available)
            ffacaFormik.setFieldValue("maleDeficiency", name[0].toilet_male_deficiency)
            ffacaFormik.setFieldValue("femaleNorms", name[0].toilet_female_norms)
            ffacaFormik.setFieldValue("femaleAvailable", name[0].toilet_female_available)
            ffacaFormik.setFieldValue("femaleDeficiency", name[0].toilet_female_deficiency)
            ffacaFormik.setFieldValue("parkingNorms", name[0].parking_norms)
            ffacaFormik.setFieldValue("parkingAvailable", name[0].parking_available)
            ffacaFormik.setFieldValue("parkingDeficiency", name[0].parking_deficiency)
            ffacaFormik.setFieldValue("playgroundNorms", name[0].playground_norms)
            ffacaFormik.setFieldValue("playgroundAvailable", name[0].playground_available)
            ffacaFormik.setFieldValue("playgroundDeficiency", name[0].playground_deficiency)


        }

    }

    console.log("ffacaFormik", ffacaFormik?.values)
    console.log("name", name)


    useEffect(() => {
        GetFFCADetailsData();


    }, [name])

    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);


    return (
        <div>
            <bie.Modal show={showModal} onHide={handleClose} size="xl" backdrop="static" keyboard={false}>
                <bie.Modal.Header style={{ backgroundColor: '#6f7cc3' }} >
                    <bie.Modal.Title style={{ textAlign: "center", width: "100%" }}>Note </bie.Modal.Title>
                    <button type="button" onClick={() => { handleClose() }}
                        style={{ color: "brown", fontSize: "17px", fontWeight: "bold" }} aria-label="Close"><h3>x</h3>
                    </button>
                </bie.Modal.Header>
                <bie.Modal.Body>
                    <bie.Alert variant="danger" className='affl-alert' >
                        <p className="mb-0">Note : Please enter area values as follows:<br />
                            1: APCHE approved courses: Enter in **square feet** (sq.ft).<br />
                            2: AICTE approved courses: Enter in **square meters** (sq.mtr).<br />
                        </p>
                    </bie.Alert>
                </bie.Modal.Body>
            </bie.Modal>



            <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-3" >
                <FormikProvider value={ffacaFormik}>
                    <Form onSubmit={ffacaFormik.handleSubmit} onChange={ffacaFormik.handleChange}>


                        <bie.Row className='pt-3'>
                            <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <bie.Alert variant="danger" className='affl-alert' >
                                    <p className="mb-0">Note : Please enter area values as follows:<br />
                                        1: APCHE approved courses: Enter in **square feet** (sq.ft).<br />
                                        2:For AICTE approved courses: Enter in **square meters** (sq.m).<br />
                                    </p>
                                </bie.Alert>
                            </bie.Col>
                        </bie.Row>


                        <div className="px-1">
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className=""> Land </h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                    <thead>
                                        <tr>
                                            <th>Extent of Land own / Leased</th>
                                            <th>Required as per norms ({LandType})</th>
                                            <th>Available ({LandType})</th>
                                            <th>Deficiency ({LandType})</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>
                                                <Field as="select" className="form-control" name="ownLeased" >
                                                    <option value="">--Select--</option>
                                                    <option value="Leased">Leased</option>
                                                    <option value="Own">Own</option>
                                                </Field>
                                                <ErrorMessage name="ownLeased" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="landNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("landAvailable", "")
                                                        ffacaFormik.setFieldValue("landDeficiency", "")
                                                    }}
                                                />
                                                <ErrorMessage name="landNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="landAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("landAvailable", "landNorms", "landDeficiency", "Land")} />
                                                <ErrorMessage name="landAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="landDeficiency" disabled />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>

                        <div className="px-1">
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className=""> Accommodation </h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Particulars</th>
                                            <th>Required as per norms ({LandType})</th>
                                            <th>Available ({LandType})</th>
                                            <th>Deficiency ({LandType})</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td style={{ textAlign: "left" }}>No. of Classrooms </td>

                                            <td>
                                                <Field type="text" className="form-control" name="noOfClassroomsNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("noOfClassroomsAvailable", "")
                                                        ffacaFormik.setFieldValue("noOfClassroomsDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="noOfClassroomsNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="noOfClassroomsAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("noOfClassroomsAvailable", "noOfClassroomsNorms", "noOfClassroomsDeficiency", "Classrooms")} />
                                                <ErrorMessage name="noOfClassroomsAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="noOfClassroomsDeficiency" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td style={{ textAlign: "left" }}>No. of Labs </td>

                                            <td>
                                                <Field type="text" className="form-control" name="noOfLabsNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("noOfLabsAvailable", "")
                                                        ffacaFormik.setFieldValue("noOfLabsDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="noOfLabsNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="noOfLabsAvailable"

                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("noOfLabsAvailable", "noOfLabsNorms", "noOfLabsDeficiency", "Labs")
                                                    } />
                                                <ErrorMessage name="noOfLabsAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="noOfLabsDeficiency" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td style={{ textAlign: "left" }}>Library  </td>

                                            <td>
                                                <Field type="text" className="form-control" name="noOfLibraryNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("noOfLibraryAvailable", "")
                                                        ffacaFormik.setFieldValue("noOfLibraryDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="noOfLibraryNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="noOfLibraryAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("noOfLibraryAvailable", "noOfLibraryNorms", "noOfLibraryDeficiency", "Library")
                                                    } />
                                                <ErrorMessage name="noOfLibraryAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="noOfLibraryDeficiency" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td style={{ textAlign: "left" }}>No. Titles  </td>

                                            <td>
                                                <Field type="text" className="form-control" name="noOfTitlesNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("noOfTitlesAvailable", "")
                                                        ffacaFormik.setFieldValue("noOfTitlesDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="noOfTitlesNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="noOfTitlesAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("noOfTitlesAvailable", "noOfTitlesNorms", "noOfTitlesDeficiency", "No. Titles")
                                                    } />
                                                <ErrorMessage name="noOfTitlesAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="noOfTitlesDeficiency" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td style={{ textAlign: "left" }}>No. of Volume</td>

                                            <td>
                                                <Field type="text" className="form-control" name="noOfVolumeNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("noOfVolumeAvailable", "")
                                                        ffacaFormik.setFieldValue("noOfVolumeDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="noOfVolumeNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="noOfVolumeAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("noOfVolumeAvailable", "noOfVolumeNorms", "noOfVolumeDeficiency", "No. of Volume")
                                                    } />
                                                <ErrorMessage name="noOfVolumeAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="noOfVolumeDeficiency" disabled />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>

                        <div className="px-1">
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className=""> Administrative Accommodate </h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Particulars</th>
                                            <th>Plinth area Required as per norms ({LandType})</th>
                                            <th>Available ({LandType})</th>
                                            <th>Deficiency ({LandType})</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td style={{ textAlign: "left" }}>Principal room </td>

                                            <td>
                                                <Field type="text" className="form-control" name="principalRoomNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("principalRoomAvailable", "")
                                                        ffacaFormik.setFieldValue("principalRoomDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="principalRoomNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="principalRoomAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("principalRoomAvailable", "principalRoomNorms", "principalRoomDeficiency", "Principal room")
                                                    } />
                                                <ErrorMessage name="principalRoomAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="principalRoomDeficiency" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td style={{ textAlign: "left" }}>Staff Room </td>

                                            <td>
                                                <Field type="text" className="form-control" name="staffRoomNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("staffRoomAvailable", "")
                                                        ffacaFormik.setFieldValue("staffRoomDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="staffRoomNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="staffRoomAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("staffRoomAvailable", "staffRoomNorms", "staffRoomDeficiency", "Staff Room")
                                                    } />
                                                <ErrorMessage name="staffRoomAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="staffRoomDeficiency" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td style={{ textAlign: "left" }}>Seminar Hall</td>

                                            <td>
                                                <Field type="text" className="form-control" name="seminarHallNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("seminarHallAvailable", "")
                                                        ffacaFormik.setFieldValue("seminarHallDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="seminarHallNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="seminarHallAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("seminarHallAvailable", "seminarHallNorms", "seminarHallDeficiency", "Seminar Hall")
                                                    } />
                                                <ErrorMessage name="seminarHallAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="seminarHallDeficiency" disabled />
                                            </td>
                                        </tr>


                                    </tbody>
                                </table>
                            </div>

                        </div>

                        <div className="px-1">
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className=""> Others </h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Particulars</th>
                                            <th>Plinth area Required as per norms ({LandType})</th>
                                            <th>Available ({LandType})</th>
                                            <th>Deficiency ({LandType})</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td style={{ textAlign: "left" }}>Toilet for Male </td>

                                            <td>
                                                <Field type="text" className="form-control" name="maleNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("maleAvailable", "")
                                                        ffacaFormik.setFieldValue("maleDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="maleNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="maleAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("maleAvailable", "maleNorms", "maleDeficiency", "Toilet for Male")
                                                    } />
                                                <ErrorMessage name="maleAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="maleDeficiency" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td style={{ textAlign: "left" }}>Toilet for Female </td>

                                            <td>
                                                <Field type="text" className="form-control" name="femaleNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("femaleAvailable", "")
                                                        ffacaFormik.setFieldValue("femaleDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="femaleNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="femaleAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("femaleAvailable", "femaleNorms", "femaleDeficiency", "Toilet for Female")
                                                    } />
                                                <ErrorMessage name="femaleAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="femaleDeficiency" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td style={{ textAlign: "left" }}>Parking</td>

                                            <td>
                                                <Field type="text" className="form-control" name="parkingNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("parkingAvailable", "")
                                                        ffacaFormik.setFieldValue("parkingDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="parkingNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="parkingAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("parkingAvailable", "parkingNorms", "parkingDeficiency", "Parking")
                                                    } />
                                                <ErrorMessage name="parkingAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="parkingDeficiency" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td style={{ textAlign: "left" }}>Play ground</td>

                                            <td>
                                                <Field type="text" className="form-control" name="playgroundNorms"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={() => {
                                                        ffacaFormik.setFieldValue("playgroundAvailable", "")
                                                        ffacaFormik.setFieldValue("playgroundDeficiency", "")
                                                    }} />
                                                <ErrorMessage name="playgroundNorms" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="playgroundAvailable"
                                                    onKeyPress={(e) => { AllowFloats(e); }}
                                                    onPaste={(e) => { handlePaste(e) }}
                                                    onChange={
                                                        handleAvailableChange("playgroundAvailable", "playgroundNorms", "playgroundDeficiency", "Play ground")
                                                    } />
                                                <ErrorMessage name="playgroundAvailable" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="playgroundDeficiency" disabled />
                                            </td>
                                        </tr>


                                    </tbody>
                                </table>
                            </div>

                        </div>
                        {name?.length === 0 || name?.length === '' || name?.length === undefined || name?.length === null || name === "No data found" ? (<>
                            <button type="submit" className="btn btn-success btn-sm float-end"> Submit </button>
                        </>) : (<b className='float-end' style={{ color: "brown", fontSize: "20px" }}>

                            Already Submitted
                        </b>)}
                        <br />
                        <br />


                    </Form>
                </FormikProvider>
            </Container>
        </div>
    )
}
